<template>
  <div class="page-container-wrapper">
    <loader v-if="dataLoading"/>
    <template v-else>
      <div class="page-container-header d-flex align-items-center">
        <h2 class="text-md mb-0">{{ $t('message.Guideline.publications') }}</h2>
        <b-button v-if="isSuperUser" variant="info" class="mr-2 ml-auto" @click="$router.push('/')">{{ $t('message.return') }}</b-button>
      </div>

      <div class="page-container guidelines-editor" id="page-container">

        <div class="row">
          <div class="col-md-12">
            <div>
              <b-card :title="$t('message.Guideline.preApproveDraft')" class="col-12 mb-2">
                <div class="d-flex align-items-center">
                  <label :for="preApproveDraft">
                    {{ $t('message.Guideline.preApproveDraftConfirm') }}
                  </label>
                  <b-form-radio-group v-model="preApproveDraft"
                                      class="ml-5 mb-2">
                    <b-form-radio :value=true>
                      {{ $t('message.yes') }}
                    </b-form-radio>
                    <b-form-radio :value=false>
                      {{ $t('message.no') }}
                    </b-form-radio>
                  </b-form-radio-group>
                </div>

                <b-row class="mt-2 guideline-pre-approve-draft">
                  <b-col>
                    <b-alert variant="info" show v-html="$t('message.Guideline.preApproveDraftInfo')">
                    </b-alert>
                    <div v-if="preApproveDraft === false">
                      <b-alert variant="warning" show>
                        {{ $t('message.Guideline.preApproveDraftWarning') }}
                      </b-alert>
                    </div>
                  </b-col>
                </b-row>
                <div class="stepper-container flex-row-reverse">
                  <div>
                    <b-button variant="link" class="mr-2" @click="$router.push('/guidelines/')">{{ $t("message.cancel") }}</b-button>

                    <b-button variant="success" class="mr-2" @click="$router.push('/guidelines/add')" :disabled="!preApproveDraft">
                      {{ $t('message.Guideline.add') }}
                    </b-button>
                  </div>
                </div>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      preApproveDraft: null,
    };
  },
}
</script>
<style scoped lang="scss">
.guideline-pre-approve-draft {
  min-height: 10rem;
}
</style>